import React, { useEffect, useState } from "react";

import "./LastUpdate.scss";

const LastUpdate = ({ time }) => {

  const lastUpdate = time;
 
  return (
    <div className="time">
      <span> { lastUpdate } </span> (Última actualización)
    </div>
  );
};

export default LastUpdate;
